import Footer from '@Components/Footer';
import Navbar from '@Components/Navbar';
import { Overlay } from '@Components/ProfilePage/ProfilePage.styled';
import Sidebar from '@Components/SideBar';
import { DefaultSeoProps, NextSeo } from 'next-seo';
import { Fragment, memo, ReactNode, useState } from 'react';
import { Col, Container, Row } from 'styled-bootstrap-grid';
import { Main, ProfileWrapper } from './Layout.styled';
interface Props {
  children: ReactNode;
  seoData: DefaultSeoProps;
  noFollow?: boolean;
  hideNavbar?: boolean;
  hideSideBar?: boolean;
}

export default memo(function ProfileLayout({ children, hideSideBar, seoData, noFollow, hideNavbar }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Fragment>
      <NextSeo {...seoData} {...(noFollow && { nofollow: true, noindex: true })} />
      {!hideNavbar && <Navbar />}
      <ProfileWrapper>
        {!hideSideBar && <Sidebar show={isOpen} />}
        <Container>
          <Row>
            <Col>
              <Main>{children}</Main>
            </Col>
          </Row>
        </Container>
        <Overlay />
      </ProfileWrapper>
      <Footer />
    </Fragment>
  );
});
